import React from 'react';

import { powerPlants } from '../actions/powerPlantsArray';
import { plots } from '../actions/plotsArray';

import { Selectpowerplant } from './interactive/selectPowerplant';
import { EntitiesArray } from './island';
import { Dashboard } from './dashboard';

import { Destroyservice } from './interactive/destroyService';

import '../functions/player';


export class Plot extends React.Component {
  constructor(props) {
    super(props);

    if( this.props.internal ){
      let owner = EntitiesArray.find((current) => { return current.name === this.props.internalData.owner});
      let defaultImage;
      let propClass;
      if(owner.type === "supplier"){
        defaultImage = require("../assets/elements/Plot-internal.svg");
        propClass = "boardElement--plot-lg";
      } else {
        defaultImage = require("../assets/elements/Icon - add decentral.svg");
        propClass = "boardElement--plot";
      }
      this.state = {
        slotNo: this.props.internalData.slotNo,
        self: owner,
        internal: owner,
        isOpen: false,
        name: owner.name,
        production: "",
        color: owner.color,
        plantActive: false,
        plant: false,
        image: defaultImage,
        imageStyle: this.props.internalData.style || {display: 'none'},
        parentCallback: 'default',
        update: this.props.update,
        soldMwu: 0,
        propClass: propClass,
      }

    } else {
      let self = plots.filter((current) => { return current.id === parseInt(this.props.id, 10) })[0];
      this.state = {
        id: this.props.id,
        self: self,
        internal: false,
        isOpen: false,
        name: self.name,
        production: "",
        color: self.color,
        plantActive: false,
        plant: false,
        buyer: false,
        image: require("../assets/elements/Plot.svg"),
        imageStyle: self.imageStyle || {display: 'none'},
        parentCallback: 'default',
        update: this.props.update,
        soldMwu: 0,
        propClass: "boardElement--plot-lg"
      }
    }
  }

  createAlert = (msg) => {
    if(this.state.internal === false){
      this.props.handleAlert(msg);
    } else {
      this.props.createAlert(msg);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.update !== this.state.update) {
      this.getActivePlot();
    }

    if (nextProps.openModal === true) {
      this.toggleModal();
    }
  }

  getActivePlot = () => {
    if(this.state.internal !== false){
      let obj = this.state.internal;

      let slots = obj.getOwnedServices().filter((current) => { return current.external === false && current.demolished === false && current.purchasedBy !== "false" });
      if(slots.length < 0){
        return;
      } else {
        let current;
        if(this.state.slotNo === 0 && slots.length >= 1){
          current = slots[this.state.slotNo];
        } else if(this.state.slotNo === 1 && slots.length === 2){
          current = slots[this.state.slotNo];
        } else if(this.state.slotNo === 1 && slots.length === 1){
          if(this.state.internal !== false){
            let defaultImage;
            if(this.state.self.type === "city" || this.state.self.type === "company"){
              defaultImage = require("../assets/elements/Icon - add decentral.svg");
            } else {
              defaultImage = require("../assets/elements/Plot-internal.svg");
            }
            this.setState({
              plantActive: false,
              image: defaultImage,
              imageStyle: this.props.internalData.style || {display: 'none'},
            })
          }
          return;
        } else {
          return;
        }

        let image;
        let imageStyle;
        if(typeof(current.image) === "string"){
          image = current.image;
          if(Array.isArray(current.imageStyle)){
            if(obj.type === "company"){
              imageStyle = current.imageStyle[1];
            } else {
              imageStyle = current.imageStyle[0];
            }
          } else {
            imageStyle = current.imageStyle;
          }
        } else if(current.image[0] === "Windfarm"){
          image = current.image[1];
          imageStyle = current.imageStyle[1];
        } else {
          image = current.image[0];
          imageStyle = current.imageStyle[0];
        }


        const soldMwu = this.state.internal.soldMwu
          .filter((selected) => {return selected.name === current.name} )
          .reduce((accumilator, selected) => { return selected.mwu + accumilator}, 0);

        this.setState({
          plantActive: true,
          plant: current,
          self: current,
          image: require("../assets/elements/" + image + ".svg"),
          imageStyle: {...this.state.imageStyle, ...imageStyle},
          soldMwu: soldMwu
        })
      }
    } else {
      let plant = powerPlants.find((current) => { return current.external !== false && current.demolished === false && current.external === this.state.id});
      if(plant === undefined){
        return;
      } else {
        let current = plant;
        let image;
        let imageStyle;
        if(typeof(current.image) === "string"){
          image = current.image;
          if(Array.isArray(current.imageStyle)){
            imageStyle = current.imageStyle[0];
          } else {
            imageStyle = current.imageStyle;
          }
        } else if(current.image[0] === "Windfarm"){
          image = current.image[0];
          imageStyle = current.imageStyle[0];
        } else {
          if(this.state.self.sea === true){
            image = current.image[1];
            imageStyle = current.imageStyle[1];
          } else {
            image = current.image[0];
            imageStyle = current.imageStyle[0];
          }
        }

        let name = (typeof(current.purchasedBy) === "string" ? current.purchasedBy : current.purchasedBy[0]);
        let owner = EntitiesArray.find((select) => { return select.name === name});

        let soldMwu = owner.soldMwu
          .filter((selected) => {return selected.name === current.name} )
          .reduce((accumilator, selected) => { return selected.mwu + accumilator}, 0);

        if(typeof(current.purchasedBy) === "object"){
          let nextOwner = EntitiesArray.find((select) => { return select.name === current.purchasedBy[1]});
          soldMwu += nextOwner.soldMwu
            .filter((selected) => {return selected.name === current.name} )
            .reduce((accumilator, selected) => { return selected.mwu + accumilator}, 0);
        }

        this.setState({
          plantActive: true,
          plant: current,
          self: current,
          image: require("../assets/elements/" + image + ".svg"),
          imageStyle: {...this.state.imageStyle, ...imageStyle},
          buyer: owner,
          color: owner.color,
          soldMwu: soldMwu
        })
      }
    }
  }

  componentDidMount(){
    this.getActivePlot();
  }

  changeDashboard = (pass) => {
    if(pass.type === "upgrade"){
      if (!this.getUpgradeActive(pass.id)) {
        this.refs.dashboard.setState({
          parentCallback: pass,
        });
      }
    } else {
      this.refs.dashboard.setState({
        parentCallback: pass,
      });
    }
  }

  handleDemolishCallback = (data) => {
    if(data.name !== false){
      data.entities = this.props.entities;

      let object;
      if(this.state.internal === false){
        object = powerPlants.find((current) => { return current.external === this.state.id });
      } else {
        object = this.state.self;
      }
      const ownerString = (typeof(object.purchasedBy) === "string" ? object.purchasedBy : object.purchasedBy[0]);
      let owner;
      if(this.state.internal === false){
        owner = EntitiesArray.find((current) => {return current.name === ownerString});
      } else {
        owner = this.state.internal;
        data.entities = EntitiesArray;
      }

      const res = owner.demolishCentral(data);

      if(res !== true){
        this.createAlert("Het is niet gelukt om de centrale te slopen. Controleer de ingevulde gegevens. " + res)
        return;
      }

      this.props.handlePurchase({ buyWith: data.buyWith, type: "demolish" });

      if(this.state.internal !== false){
        let defaultImage;
        if(this.state.self.type === "city" || this.state.self.type === "company"){
          defaultImage = require("../assets/elements/Icon - add decentral.svg");
        } else {
          defaultImage = require("../assets/elements/Plot-internal.svg");
        }
        this.setState({
          plantActive: false,
          image: defaultImage,
          imageStyle: this.props.internalData.style || {display: 'none'},
        })
      } else {
        let self = plots.filter((current) => { return current.id === parseInt(this.props.id, 10) })[0];
        this.setState({
          plantActive: false,
          color: self.color,
          image: require("../assets/elements/Plot.svg"),
          imageStyle: self.imageStyle || {display: 'none'},
        })

        this.toggleModal();
      }

      this.updateVariables();
      this.getActivePlot();
    } else {
      this.createAlert("Je moet een centrale selecteren voordat je die kunt slopen.")
    }

  };

  updateVariables = () => {
    if(this.state.plant !== false){
      let plant = powerPlants.filter((current) => {return current.demolished === true && current.external === this.state.id});
      if(plant.length > 0){
        const self = plots.filter((current) => { return current.id === parseInt(this.props.id, 10) })[0];
        this.setState({
          name: self.name,
          production: "",
          plantActive: false,
          plant: false,
          buyer: false,
          image: require("../assets/elements/Plot.svg"),
          imageStyle: self.imageStyle || {display: 'none',}
        })
        return;
      }

      let builton = powerPlants.filter((current) => {return current.demolished === false && current.external === this.state.id});
      if(builton.length > 0){
        let plot = builton[0];
        this.getPlots(plot);

        this.getActivePlot();
        return;
      }
      return;
    }

    let builton = powerPlants.filter((current) => {return current.demolished === false && current.external === this.state.id});
    if(builton.length > 0){
      let plot = builton[0];
      this.getPlots(plot);

      let name = (typeof(plot.purchasedBy) === "string" ? plot.purchasedBy : plot.purchasedBy[0]);
      let buyer = EntitiesArray.find((select) => { return select.name === name});

      let soldMwu = 0;

      const sold1 = buyer.soldMwu
        .filter((current) => {return current.name === plot.name} )
        .reduce((accumilator, current) => { return current.mwu + accumilator}, 0);

      let sold2 = 0;
      if(typeof(plot.purchasedBy) !== "string"){
        let buyer = EntitiesArray.find((select) => { return select.name === plot.purchasedBy[1]});
        sold2 = buyer.soldMwu
          .filter((current) => {return current.name === plot.name} )
          .reduce((accumilator, current) => { return current.mwu + accumilator}, 0);
      }

      soldMwu = sold1 + sold2;

      this.setState({
        buyer: buyer,
        plantActive: true,
        plant: plot,
        color: buyer.color,
        name: plot.name,
        production: " - " + plot.mwu + " Mwu",
        soldMwu: soldMwu
      });

      return;
    }
  }

  getPlots(plantInput){
    const plant = plantInput;
    let ix = 0;
    if (this.state.self.sea) {
      ix = 1;
    }

    if(plant.image[0] === "Windfarm"){
      ix = 0;
    }

    this.setState({
      image: require("../assets/elements/" + plant.image[ix] + ".svg"),
      imageStyle: {...this.state.imageStyle, ...plant.imageStyle[ix]},
    })
  }

  purchasePowerPlant = (purchaseData) => {
    if(purchaseData.name !== false){
      purchaseData.plot = this.state.id;

      const res = purchaseData.buyer.purchaseServices(purchaseData);
      if(res[0] === false){
        this.createAlert("Het is niet gelukt om de centrale te kopen. Controleer de ingevulde gegevens. " + res[1])
        return;
      } else if( res instanceof Error) {
        this.createAlert("Het is niet gelukt om de centrale te kopen. Controleer de ingevulde gegevens. " + res.message)
        return;
      }
      this.props.handlePurchase({
        market: parseInt(purchaseData.price, 10),
        buyWith: (purchaseData.buyWith === false ? false : purchaseData.buyWith.name),
        type: "powerPlant"
      });

      this.getActivePlot();
    } else {
      this.createAlert("Je moet een centrale selecteren voordat je die kunt kopen.")
    }
    this.toggleModal();
  };

  toggleModal = () => {
    this.refs.dashboard.handleModaltoggle();
  }

  getForm = () => {

    return (
      <Selectpowerplant createAlert={this.createAlert} marine={this.state.self.marine} supplier="true" external="true" internal={this.state.internal} entities={this.props.entities} self={false} callbackPurchase={this.purchasePowerPlant} />
    );
  }

  getModal = () => {
    let modalCode;

    if(this.state.plantActive === false){
      modalCode = (
        <Dashboard parentCallback={this.state.parentCallback} ref="dashboard" headerText={this.state.name} color={this.state.color} self={(this.state.internal === false ? this.state.self : this.state.internal)}>
          <div className="row">
            {this.getForm()}
          </div>
        </Dashboard>
      );
    } else {

      let buyer = "";
      ( typeof(this.state.plant.purchasedBy) !== "object" ? buyer = this.state.plant.purchasedBy : buyer = this.state.plant.purchasedBy[0] + " & " + this.state.plant.purchasedBy[1]);

      let numMwu = ( typeof(this.state.plant.purchasedBy) !== "object" ? this.state.plant.mwu.toFixed(0) : this.state.plant.mwu.toFixed(0) );

      modalCode = (
        <Dashboard parentCallback={this.state.parentCallback} ref="dashboard" headerText={this.state.name} color={this.state.color} self={(this.state.internal === false ? this.state.self : this.state.internal)}>
          <div className="row">
            <div className="col col--data col--data-small">
              <table className="purchaseComparison">
                <tbody>
                  <tr>
                    <td>Elektriciteitsproductie</td>
                    <td className="value">{numMwu}</td>
                    <td>MWU</td>
                  </tr>
                  <tr>
                    <td>Verkocht</td>
                    <td className="value">{this.state.soldMwu.toFixed(0)}</td>
                    <td>MWU</td>
                  </tr>
                  <tr>
                    <td>Productie</td>
                    <td className="value">{(this.state.plant.green ? "100%" : "0%")}</td>
                    <td>duurzaam</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="col col--data col--data-small">
              <h2>Eigenaar</h2>
              <p>{buyer}</p>
            </div>
          </div>
          <div className="row">
            <Destroyservice createAlert={this.createAlert} callbackDemolish={this.handleDemolishCallback} internal={this.state.internal} external={true} object={this.state.self}/>
          </div>
        </Dashboard>
      );
    }

    return modalCode;
  }

  getHud = () => {
    if(this.state.plantActive !== false){
      let hudStyle = {};
      if(this.state.plant.hudStyle !== undefined){
        if(this.state.internal === false){
          hudStyle = this.state.plant.hudStyle[1];
          if(this.state.plant.image[0] === "Windfarm"){
            hudStyle = this.state.plant.hudStyle[0];
          }
        } else if(this.state.internal.type === "supplier") {
          hudStyle = this.state.plant.hudStyle[0];
        } else {
          return;
        }
      } else {
        return
      }

      let numMwu = ( typeof(this.state.plant.purchasedBy) !== "object" ? (this.state.plant.mwu - this.state.soldMwu).toFixed(0) : (this.state.plant.mwu - this.state.soldMwu).toFixed(0) );

      return(
        <div className="hud" style={this.state.imageStyle} onClick={this.toggleModal}>
          <div className="inner inner--plantHUD" style={hudStyle}>
            <div className="hudContent">
              <div className="name" style={{opacity: .5, backgroundColor: this.state.color}}>
                <div className="name-text">{numMwu} MWU</div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  render() {
    return(
      <div className="entityWrap">
        {this.getHud()}
        <img className={"boardElement " + this.state.propClass} src={this.state.image} alt='Board Element' style={this.state.imageStyle} onClick={this.toggleModal}/>
        {this.getModal()}
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/plot.js